module.exports = __webpack_public_path__ + "img/no_team_selected.0ff6f0f0.svg";